const snakeCaseRegex = /^([a-z]{1,})(_[a-z0-9]{1,})*$/;

const isSnakeCase = (input: string): boolean => snakeCaseRegex.test(input);

export default isSnakeCase;
